import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { LifecycleService } from '../core/lifecycle.service';
import { AuthService } from './auth.service';

/**
 * Prevents access to the app when the tenant workspace is frozen or purged.
 * Redirects to /frozen. Only runs for authenticated users.
 */
export const lifecycleGuard: CanActivateFn = () => {
  const lifecycle = inject(LifecycleService);
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn) return true; // authGuard handles unauthenticated

  return lifecycle.getStatus().pipe(
    map(status => {
      if (lifecycle.isFrozenOrPurged(status.billingStatus)) {
        router.navigate(['/frozen']);
        return false;
      }
      return true;
    }),
    catchError(() => of(true)), // on error, allow access — don't lock users out due to API failure
  );
};
